import css from '../sass/theme.scss'; // load in styles
import fitvids from 'fitvids';
var weba = weba || {},
	$ = jQuery,
	$document = $( document ),
	$window = $( window ); 

// Init on content loaded
window.addEventListener('DOMContentLoaded', function ( ) {
	weba.mainMenu.init();
	weba.content.init();
	weba.shortcodes.init();
});

/*	-----------------------------------------------------------------------------------------------
	Main Menu
--------------------------------------------------------------------------------------------------- */
// Each object contains an init function which initalizes all the functions within the object.
// This means that each function can have the logic within it and functions can be turned on and
// off within the init which makes for customization for future client work

weba.mainMenu = {
	init: function( ) {
		// weba.mainMenu.expandDropdownMenu();
		const siteNavigation = document.getElementById('site-navigation');
		
		if (siteNavigation) {
			const hamburgerMenu = siteNavigation.getElementsByClassName('menu--toggle')[0];
			const dropdownButtons = siteNavigation.getElementsByClassName('nav_item__submenu--toggle');
			
			Array.prototype.forEach.call(dropdownButtons, function(el, i){
				el.addEventListener('click', function() {
					let thisItemIndex = i;
					Array.prototype.forEach.call(dropdownButtons, function(el, i){
						if( i !== thisItemIndex ) {
							el.setAttribute( 'aria-expanded', 'false' );
						}
					});
					if ( el.getAttribute( 'aria-expanded' ) === "true" ) {
						el.setAttribute( 'aria-expanded', 'false' );
					} else {
						el.setAttribute( 'aria-expanded', 'true' );
					}
				} );
			});

			
			// Return early if the button doesn't exist.
			if ( 'undefined' === typeof hamburgerMenu ) {
				return;
			}

			const menu = siteNavigation.getElementsByTagName('ul')[ 0 ];

			// Hide menu toggle button if menu is empty and return early.
			if ( 'undefined' === typeof menu ) {
				hamburgerMenu.style.display = 'none';
				return;
			}

			if ( ! menu.classList.contains('nav-menu') ) {
				menu.classList.add('nav-menu');
			}

			// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
			hamburgerMenu.addEventListener('click', function() {
				// Add class to body
				document.body.classList.toggle('has-mobile-menu-open');
				siteNavigation.classList.toggle('is-menu-open');

				if ( hamburgerMenu.getAttribute( 'aria-expanded' ) === 'true' ) {
					hamburgerMenu.setAttribute( 'aria-expanded', 'false' );
				} else {
					hamburgerMenu.setAttribute( 'aria-expanded', 'true' );
				}
			} );

			// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
			document.addEventListener( 'click', function( event ) {
				const isClickInside = siteNavigation.contains( event.target );

				if ( ! isClickInside ) {
					siteNavigation.classList.remove( 'toggled' );
					hamburgerMenu.setAttribute( 'aria-expanded', 'false' );
				}
			} );
		}
	},

	// Minize header / add class when you scroll down
	minimizeHeader: function() {
		let lastScrollTop = 0;
		window.addEventListener( 'scroll', function() {
			const st = window.pageYOffset || document.documentElement.scrollTop;
			if ( st > lastScrollTop && st >= 100 ) {
				// downscroll code
				$( 'body' ).addClass( 'header--scrolled' );
				if ( st > lastScrollTop && st >= 250 ) {
					$( 'body' ).addClass( 'header--hide' );
				} else { }
			} else {
				$( 'body' ).removeClass( 'header--hide' );
				if ( st <= 100 ) {
					$( 'body' ).removeClass( 'header--scrolled' );
				}
			}
			lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
		}, false );
	},
}; // weba.mainMenu

/*	-----------------------------------------------------------------------------------------------
	Content Functions - Anything appearing on a standard page
--------------------------------------------------------------------------------------------------- */
weba.content = {
	init: function() {
		weba.content.initResponsiveVideo();
	},

	/*
	 * Use Fitvids to make Yotube/Vimeo fit the container width
	 *
	 * @see https://www.npmjs.com/package/fitvids
	 */
	initResponsiveVideo: function() {
		const videoWrapper = $( '.wp-block-embed-youtube' );
		const gutenbergEmbedWrapper = $( '.wp-block-embed__wrapper' );
		if ( videoWrapper.length > 0 || gutenbergEmbedWrapper.length > 0 ) {
			fitvids( videoWrapper );
		}
	},
};

/*	-----------------------------------------------------------------------------------------------
	Helper Functions - Not loaded on content load, but used as utility functions for sliders, resize etc
--------------------------------------------------------------------------------------------------- */
weba.helpers = {

	throttle: function( callback, limit ) {
		let wait = false; // Initially, we're not waiting
		return function() { // We return a throttled function
			if ( ! wait ) { // If we're not waiting
				callback.call(); // Execute users function
				wait = true; // Prevent future invocations
				setTimeout( function() { // After a period of time
					wait = false; // And allow future invocations
				}, limit );
			}
		};
	},

	/**
	 * @param {number} seconds Time in seconds
	 * @return {number} millisecond version
	 */
	getMillisecondAmount: function( seconds ) {
		if ( seconds === 0 ) {
			return 0;
		} else if ( seconds === 1 ) {
			return parseInt( seconds + '000' ); // e.g. 1000
		} else if ( seconds > 1 && seconds < 10 ) {
			if ( weba.helpers.isFloat( seconds ) ) {
				return parseInt(seconds.toString().replace( /\./g, '' ) + '00'); // e.g. 1900
			}
			return parseInt(seconds + '000'); // e.g. 10,000
		} else if ( seconds >= 10 ) {
			if ( weba.helpers.isFloat( seconds ) ) {
				return parseInt(seconds.toString().replace(/\./g, '') + '00');
			}
			return parseInt(seconds.toString().replace(/\./g, '') + '000');
		} else if (seconds >= 0 && seconds < 1) {
			return parseInt(seconds.toString().replace(/\./g, '') + '00'); // e.g. 200
		}
	},

	isInteger: function (x) {
		return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
	},
	isFloat: function (x) {
		return !! (x % 1);
	},
}; // weba.helpers

/*	-----------------------------------------------------------------------------------------------
	Shortcode Functions - These are created when shortcodes are used.
--------------------------------------------------------------------------------------------------- */
weba.shortcodes = {
	init: function() {
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
		const moduleCarousel = document.querySelectorAll( '.module-image__wrapper' );
		if ( ! mediaQuery || mediaQuery.matches ) {
			return;
		}
		if ( moduleCarousel.length ) {
			weba.shortcodes.initModulePageIcon();
		}
	},

	initModulePageIcon: function() {
		const wrapper  = document.querySelectorAll( '.module-image__wrapper' );
		const mainLogo = document.getElementById( 'module-block--icon' );
		const allLogos = window.agilechilli_module_images.images;
		
		let cycleSpeed = 2000; // Default 2 seconds.
		if( wrapper[0].getAttribute('data-cycle-speed') ) {
			cycleSpeed = wrapper[0].getAttribute('data-cycle-speed');
		}
		
		let currentImageIndex = 1;

		// Only proceed if items in array
		if ( allLogos.length ) {

			// Replace the main-logo with named item in array.
			setInterval( function() {
				mainLogo.src = allLogos[currentImageIndex].src;
				// Adjust the reset counter based on length of array.
				if ( currentImageIndex === ( allLogos.length - 1 ) ) {
					currentImageIndex = 0;
				} else {
					currentImageIndex++;
				}
			}, cycleSpeed );
		}
	},
}
